import React from 'react';

import { figure, percent } from './contractorFormat';

import TableRowSkeleton from 'CommonComponents/TableRowSkeleton';

export default function VenueContractorsByFunctionalAreaTable({ rows, totals, loading }) {
    return (
        <div className="inbud-table_wrapper">
            <table className="inbud-table tw-min-w-[48rem]">
                <thead>
                    <tr>
                        <th className="!tw-text-start">{$t('Functional area')}</th>
                        <th>{$t('Packs')}</th>
                        <th>{$t('Days')}</th>
                        <th>{$t('Contractor shifts')}</th>
                        <th>{$t('Hours')}</th>
                        <th>{$t('Cost')}</th>
                        <th className="tw-w-56">{$t('Share of venue contractor cost')}</th>
                    </tr>
                </thead>
                <tbody>
                    {loading && <TableRowSkeleton rows={5} columns={7} />}
                    {!loading &&
                        rows.map((area) => (
                            <tr key={`${area.type}-${area.id}`}>
                                <td className="tw-font-semibold">{area.name}</td>
                                <td className="inbud-numeric-cell">{figure(area.packs)}</td>
                                <td className="inbud-numeric-cell">{figure(area.days)}</td>
                                <td className="inbud-numeric-cell">{figure(area.shifts)}</td>
                                <td className="inbud-numeric-cell">{figure(area.hours)}</td>
                                <td className="inbud-numeric-cell">{figure(area.cost)}</td>
                                <td>
                                    <div className="tw-flex tw-items-center tw-gap-x-2">
                                        <div className="tw-h-2 tw-flex-1 tw-rounded-full tw-bg-grey tw-overflow-hidden" aria-hidden="true">
                                            <div className="tw-h-full tw-bg-blue" style={{ width: percent(Math.min(1, area.share)) }} />
                                        </div>
                                        <span className="tw-font-mono tw-w-10 tw-text-end">{percent(area.share)}</span>
                                    </div>
                                </td>
                            </tr>
                        ))}
                </tbody>
                {!loading && totals && (
                    <tfoot>
                        <tr>
                            <td>{$t('Total')}</td>
                            <td className="inbud-numeric-cell">{figure(totals.packs)}</td>
                            <td className="inbud-numeric-cell">{figure(totals.days)}</td>
                            <td className="inbud-numeric-cell">{figure(totals.shifts)}</td>
                            <td className="inbud-numeric-cell">{figure(totals.hours)}</td>
                            <td className="inbud-numeric-cell">{figure(totals.cost)}</td>
                            <td />
                        </tr>
                    </tfoot>
                )}
            </table>
        </div>
    );
}
